import type {
	Components,
} from '@mui/material'

export const materialUIStepperTheme: {
	components: Components
} = {
	components: {
		MuiStepper: {
			styleOverrides: {
			},
		},

		MuiStepLabel: {
			styleOverrides: {
			},
		},
	},
}
